import * as React from 'react';
import {FunctionComponent} from 'react';
import {classNames} from '../../Support/classNames';

interface OwnProps {
    className?: string;
}

function useValidationError(key: string): string[] {
    const validationErrors = (window as any).validationErrors || {};

    return validationErrors[key] || null;
}

export const UploadForm: FunctionComponent<OwnProps> = ({className}) => {
    const validationErrors = useValidationError('file');
    return (
        <div className={classNames('card', className)}>
            <div className="card-title">
                <h5>Workout import</h5>
            </div>
            <div className="card-body">
                <form action="/workouts/import" method="post" encType="multipart/form-data">
                    <input
                        name="_token"
                        type="hidden"
                        value={document.querySelector('meta[name="csrf-token"]')!.getAttribute('content')!}
                    />
                    <p>Upload a .tcx or .fit file from your rowing outing. Both indoor and outdoor.</p>
                    <div className="form-group">
                        <input
                            type="file"
                            className={classNames('form-control', {'is-invalid': validationErrors !== null})}
                            name="file"
                            accept=".tcx,.fit"
                        />
                        {validationErrors && (
                            <div className="invalid-feedback">
                                {validationErrors.map((error: string, index: number) => (
                                    <div key={index}>{error}</div>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className="d-flex flex-row justify-content-end mt-2">
                        <button type="submit" className="btn btn-primary">
                            Upload
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
